import { render } from "./EmailAccountModal.vue?vue&type=template&id=8ec5a37a&scoped=true"
import script from "./EmailAccountModal.vue?vue&type=script&lang=js"
export * from "./EmailAccountModal.vue?vue&type=script&lang=js"

import "./EmailAccountModal.vue?vue&type=style&index=0&id=8ec5a37a&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec5a37a"]])

export default __exports__